<template>
  <div id="login-wrap">
    <div class="header">车家</div>
    <div class="container">
      <div class="caption">手机验证</div>
      <div class="mobile_verification_part">
        <div class="mobile_verification_img"><img src="../assets/image/Login/mobile_icon.png"/></div>
        <div class="item">
          <input type="tel" v-model="mobile" placeholder="请输入手机号码" class="mobile_in" @focus="focusBottomColor" @blur="blurBottomColor" maxlength="11"/>
        </div>
        <div class="item">
          <input type="number" v-model="vCode" placeholder="请输入验证码" class="code_in" @focus="focusBottomColor" @blur="blurBottomColor" v-on:input="VCodeMaxLength"/>
          <button @click="getVCode" v-html="vCodeStr"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'mint-ui'
  import common from '../utils/common'
  import qs from 'qs';
  export default {
    name: "login",
    data(){
      return {
        inFocus: false,
        mobile: '',
        vCode: null,
        vCodeStr: '获取验证码',
        timeCount: 60,
        timer: null
      }
    },
    mounted(){
      window.scrollTo(0, 0)
    },
    methods: {
      // input type='number'时maxlength无效，用此方法限定最大输入长度
      VCodeMaxLength() {
        if (this.vCode != null && this.vCode.length > 6) {
          this.vCode = this.vCode.slice(0, 6)
        }
        if (this.vCode != null && this.vCode.length === 6) {
          if(common.trimAll(this.mobile) == null){
            Toast({
              message: "请输入手机号码",
              className: 'longMsgStyle'
            })
            return
          }else{
            if(!common.checkMobile(this.mobile)){
              Toast({
                message: "手机号码格式不正确",
                className: 'longMsgStyle'
              })
              return
            }
          }
          const router = this.$router
          const that = this
          let data = {"mobile": that.mobile,
              "code": that.vCode,
              "carModel": ''}
          that.$axios.post('/marketing/checkcode', qs.stringify(data)).then(function (res) {
            // if(res.data.data.code == '0'){}
            sessionStorage.setItem("mobilePhone", that.mobile)
            if(res.data.data == null){
              sessionStorage.setItem("userId",  '')
            }else{
              sessionStorage.setItem("userId",  res.data.data)
            }
            router.push({
              path: '/photo',
              name: "Photo",
              params: {}
            })
          }).catch(function (error) {
            Toast({
              message: error.data.msg,
              className: 'longMsgStyle'
            })
            return
          });
        }
      },
      // 输入框获取或失去焦点时 底部边框颜色变化
      focusBottomColor(e) {
        e.currentTarget.parentNode.style.backgroundImage = 'linear-gradient(-90deg, #2694ff 0%, #42da94 100%),linear-gradient(#f4f4f4,#f4f4f4)'
        this.inFocus = true
      },

      blurBottomColor(e) {
        e.currentTarget.parentNode.style.backgroundImage = 'none'
        this.inFocus = false
        setTimeout(function () {
          if(!this.inFocus){
            // 当input 失焦时,滚动一下页面就可以使页面恢复正常
            const timer = setInterval(() => {
              let currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
              const speed=1;//页面滚动距离
              currentPosition-=speed;
              window.scrollTo(0, currentPosition)
              clearInterval(timer);
            }, 1)
          }
        },200)
      },
      getVCode(e){
        let that = e.currentTarget
        that.disabled = true
        this.vCodeStr = '('+ this.timeCount +'s)' + '重新获取'
        this.timer = setInterval( () => {
          this.timeCount--
          if (this.timeCount > 0) {
            this.vCodeStr = '(' + this.timeCount + 's)' + '重新获取'

          } else {
            clearInterval(this.timer); // 清除js定时器
            that.disabled = false;
            this.vCodeStr = '获取验证码';
            this.timeCount = 60; // 重置时间
          }
        }, 1000);
          let data = {"mobile": this.mobile}
        this.$axios.post('/marketing/getcode', qs.stringify(data)).then(function (res) {
          Toast({
            message: res.data.msg,
            className: 'longMsgStyle'
          })
          return
        }).catch(function (error) {
          Toast({
            message: error.data.msg,
            className: 'longMsgStyle'
          });
          return
        });
      }
    }
  }
</script>

<style scoped>
  .longMsgStyle{
    margin: 0 auto;
    width: 60%;
    left: 0!important;
    right: 0!important;
    transform: translate(-0%, -50%)!important;
  }
  html {
    background-color: #fff;
  }
  #login-wrap{
    width: 100vw;
  }

  #login-wrap > .header{
    width: 100%;
    height: 0.98rem;
    line-height: 0.98rem;
    background-color: #fff;
    color: #222;
    font-size: 0.36rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    text-align: center;
  }

  #login-wrap > .container {
    margin: 0 auto;
    margin-top: 1.5rem;
    width: 7.5rem;
  }
  #login-wrap > .container > .caption{
    margin: 0 0.86rem;
    font-size: 0.4rem;
    font-weight: normal;
    font-stretch: normal;
  }
  #login-wrap > .container > .mobile_verification_part {
    margin-top: 1.88rem;
  }
  #login-wrap > .container > .mobile_verification_part > .mobile_verification_img {
    margin-left: 0.94rem;
    width: 0.21rem;
    height: 0.32rem;
    font-size: 0;
  }
  #login-wrap > .container > .mobile_verification_part > .mobile_verification_img > img {
    width: 100%;
  }
  #login-wrap > .container > .mobile_verification_part > .item{
    margin-left: 0.86rem;
    padding-bottom: 0.04rem;
    width: 5.89rem;
    background-color: #f4f4f4;
    background-image: none;
    border-radius: 0.02rem;
  }
  #login-wrap > .container > .mobile_verification_part > .item > input {
    padding: 0;
    padding-left: 0.08rem;
    width: 5.89rem;
    height: 0.9rem;
    line-height: 0.32rem;
    display: block;
    font-size: 0.28rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #222222;
    outline: none;
    border-width: 0;
    border-radius: 0.02rem;
  }
  #login-wrap > .container > .mobile_verification_part > .item:last-child{
    display: flex;
    flex-flow: row nowrap;
  }
  #login-wrap > .container > .mobile_verification_part > .item:last-child > input {
    min-width: 60%;
    height: 1.02rem;
    line-height: 0.32rem;
  }
  #login-wrap > .container > .mobile_verification_part > .item:last-child > button {
    padding: 0;
    margin: 0;
    min-width: 30%;
    font-size: 0.28rem;
    height: 1.02rem;
    line-height: 1.02rem;
    text-align: right;
    font-weight: normal;
    font-stretch: normal;
    color: #666666;
    background-color: #fff;
    border-width: 0;
    outline: none;
  }
  input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: #d1d0d0;
  }
  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #d1d0d0;
  }
  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #d1d0d0;
  }
  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #d1d0d0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue